export interface SkinToneSummary {
  category: string;
}

export interface PendingAnalysisResults {
  undertone: string | null | undefined;
  skinTone: SkinToneSummary | null;
}

export interface AnalysisFailureInput {
  image: string | null;
  isLoading: boolean;
  undertoneLoading: boolean;
  undertone: string | null | undefined;
  undertoneError: string | null | undefined;
  skinTone: SkinToneSummary | null;
  /** Synchronous snapshot taken when analysis finishes, before React state flushes. */
  pendingResults?: PendingAnalysisResults | null;
}

/** True when an uploaded image cannot be analyzed (no face / unknown skin tone). */
export function shouldShowAnalysisFailure(
  input: AnalysisFailureInput
): boolean {
  const {
    image,
    isLoading,
    undertoneLoading,
    undertone,
    undertoneError,
    skinTone,
    pendingResults,
  } = input;

  if (!image || isLoading || undertoneLoading) {
    return false;
  }

  const resolvedUndertone = undertone ?? pendingResults?.undertone;
  const resolvedSkinTone = skinTone ?? pendingResults?.skinTone ?? null;

  return (
    !resolvedUndertone ||
    !!undertoneError ||
    !resolvedSkinTone ||
    resolvedSkinTone.category === 'Unknown'
  );
}
